export default "__VITE_ASSET__DIQd$7gj__"